  <!-- Animated -->
            <div class="animated fadeIn">
                <!-- <h3>Admin Panel</h3>
                <br/> -->
         
                <!--  Traffic  -->
                <div class="row">
                    <div class="col-lg-12">
                        <div class="card">
                            <div class="card-body" style="min-height: 600px;">
                                <h4 class="box-title">Add User </h4>
                                <!--<a class="float-right rtbtn btn btn-primary" style="margin-top: -35px;" (click)="logout()">Logout</a>-->
                           <br/>
                               
                           		<div class="row form-group">
                                    <div class="col col-md-3"><label for="selectSm" class=" form-control-label">
                                        Email
                                    </label></div>
                                    <div class="col-12 col-md-9">
                                        <input name="email" [(ngModel)]="email" id="email" class="form-control-sm form-control" required />
                                    </div>
                                </div>
                                 <div class="row form-group">
                                    <div class="col col-md-3"><label for="selectSm" class=" form-control-label">
                                        User ID
                                    </label></div>
                                    <div class="col-12 col-md-9">
                                        <input name="email" [(ngModel)]="username" id="username" class="form-control-sm form-control" required />
                                    </div>
                                </div>
                                <div class="row form-group">
                                    <div class="col col-md-3"><label for="selectSm" class=" form-control-label">
                                        Password
                                    </label></div>
                                    <div class="col-12 col-md-9">
                                        <input name="password" [(ngModel)]="password" id="password" class="form-control-sm form-control" required />
                                    </div>
                                </div>
                                
                                <div class="row form-group">
                                    <div class="col col-md-3"><label for="selectSm" class=" form-control-label">
                                        Re-enter Password
                                    </label></div>
                                    <div class="col-12 col-md-9">
                                        <input name="repassword" id="repassword" [(ngModel)]="repassword" class="form-control-sm form-control" required />
                                    </div>
                                </div>
                                <div class="row form-group" id="comCont" [hidden]="comVisibility">
                                    <div class="col col-md-3"><label for="selectSm" class=" form-control-label">
                                        Company
                                    </label></div>
                                    <div class="col-12 col-md-9">
                                        <select name="company" id="company" [(ngModel)]="company" class="form-control-sm form-control" >
                                            <option value="{{pdetails.companyId}}" *ngFor="let pdetails of peerData">{{pdetails.companyName}}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="row form-group">
                                    <div class="col col-md-3"><label for="selectSm" class=" form-control-label">
                                        User Role
                                    </label></div>
                                    <div class="col-12 col-md-9">
                                        <select name="role" id="role" [(ngModel)]="role" class="form-control-sm form-control" (change)="changeRole()" >
                                            <option value="1" >Admin</option>
                                            <option value="2" >Analyst</option>
                                            <option value="3" >Ceo</option>
                                            <option value="4" >Compliance</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="row form-group">
                                    <div class="col col-md-3"></div>
                                    <div class="col-12 col-md-6">
                                        <div class="form-actions form-group">
                                            <button type="submit" class="btn btn-primary btn-sm" (click)="createUser()" >Create</button>
                                             
                                        </div>

                                    </div>

                                </div>
                                <div class="row form-group">
                                    <div class="col col-md-12" id="errCont"></div>
                                </div>
                            </div>
                        </div>
                    </div><!-- /# column -->
                </div>
                <!--  /Traffic -->
                <div class="clearfix"></div>
               
              
               
                
                
            </div>
            <!-- .animated -->

























